import { api } from "./client";
import type {
  PromptCatalogEntry,
  PromptConfigurationRow,
  PromptCopyResult,
  PromptDefinitionEditor,
  PromptReconciliation,
  SavePromptOverrideRequest,
} from "@/types/prompts";

// Admin "Prompts" tool transport. Read the in-code catalog + the unified
// PromptConfiguration store, and run the copy-only backfill + reconciliation.
// (No React Query here — that lives in hooks/prompts.)
export const promptsApi = {
  catalog: () => api.get<PromptCatalogEntry[]>("/admin/prompts/catalog"),
  configurations: () =>
    api.get<PromptConfigurationRow[]>("/admin/prompts/configurations"),
  reconciliation: () =>
    api.get<PromptReconciliation>("/admin/prompts/reconciliation"),
  copyFromLegacy: () =>
    api.post<PromptCopyResult>("/admin/prompts/copy-from-legacy"),

  // Per-definition editor: the catalog default + current global override, and
  // upsert / reset of that override.
  definition: (key: string) =>
    api.get<PromptDefinitionEditor>(
      `/admin/prompts/definitions/${encodeURIComponent(key)}`,
    ),
  saveOverride: (key: string, body: SavePromptOverrideRequest) =>
    api.put<PromptDefinitionEditor>(
      `/admin/prompts/definitions/${encodeURIComponent(key)}/override`,
      body,
    ),
  deleteOverride: (key: string) =>
    api.delete<PromptDefinitionEditor>(
      `/admin/prompts/definitions/${encodeURIComponent(key)}/override`,
    ),
};
